type ConfigEnvVar = string;

type PublicEnvConfigType = {
  mainApiBaseUrl: ConfigEnvVar;
  apiBaseUrl: string;
  appDomain: string;
  googleMapsKey: string;
  env: string;
  walletConnectProjectID: string;
  webAuthEnv: string;
  web3ProjectId: string;
  caminoChainId: string;
  caminoRPC: string;
  caminoChainName: string;
  caminoExplorer: string;
  caminoTicker: string;
  caminoTickerName: string;
  publicHomeUrl: ConfigEnvVar;
  nextPublicApiBase: ConfigEnvVar;
  hotjarSiteId: string;
  hotjarVersion: string;
  infuraProjectId: string;
  maxOffersPerPage: number;
  apeChainRPC: string;
  loadZendChat: string;
  miracleApiKey: string;
};

function getPublicEnvConfig(): PublicEnvConfigType {
  return {
    mainApiBaseUrl: process.env.NEXT_PUBLIC_MAIN_API_BASE_URL ?? "",
    apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE ?? "",
    appDomain: process.env.NEXT_PUBLIC_APP_DOMAIN ?? "",
    googleMapsKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY ?? "",
    env: process.env.NEXT_PUBLIC_ENV ?? "",
    walletConnectProjectID:
      process.env.NEXT_PUBLIC_WALLET_CONNECT_PROJECT_ID ?? "",
    webAuthEnv: process.env.NEXT_PUBLIC_WEB3AUTH_ENV ?? "",
    web3ProjectId: process.env.NEXT_PUBLIC_WEB3AUTH_PROJECT_ID ?? "",
    caminoChainId: process.env.NEXT_PUBLIC_CAMINO_CHAIN_ID ?? "",
    caminoRPC: process.env.NEXT_PUBLIC_CAMINO_RPC ?? "",
    caminoChainName: process.env.NEXT_PUBLIC_CAMINO_CHAIN_NAME ?? "",
    caminoExplorer: process.env.NEXT_PUBLIC_CAMINO_EXPLORER ?? "",
    caminoTicker: process.env.NEXT_PUBLIC_CAMINO_TICKER ?? "",
    caminoTickerName: process.env.NEXT_PUBLIC_CAMINO_TICKER_NAME ?? "",
    publicHomeUrl: process.env.NEXT_PUBLIC_HOME_URL ?? "",
    nextPublicApiBase: process.env.NEXT_PUBLIC_API_BASE ?? "",
    hotjarSiteId: process.env.NEXT_PUBLIC_HOTJAR_SITE_ID ?? "",
    hotjarVersion: process.env.NEXT_PUBLIC_HOTJAR_VERSION ?? "",
    infuraProjectId: process.env.INFURA_PROJECT_ID ?? "",
    apeChainRPC: process.env.APECHAIN_RPC ?? "",
    maxOffersPerPage: parseInt(
      process.env.NEXT_PUBLIC_MAX_OFFERS_PER_PAGE ?? "50"
    ),
    loadZendChat: process.env.NEXT_PUBLIC_LOAD_ZEND_CHAT ?? "",
    miracleApiKey: process.env.MIRACLE_API_KEY ?? "",
  };
}

export const publicEnvConfig = getPublicEnvConfig();
